import React from "react";
import anexo2 from "../../../../shared/assets/logos/clients/palmeira/leis/ANEXO_2.pdf";

export const PalmeiraSolo: React.FC = () => {
    return (
        <div>
            <h5>ALERTAS INCIDENTES SOBRE O USO DO SOLO</h5>

            <ul className="pl-0 list-none list-outside">
                <li>
                    ► OS SERVIÇOS DEFINIDOS NAS CLASSIFICAÇÕES ACIMA ESTÃO
                    EXPRESSOS{" "}
                    <a href={anexo2} target="_blank" rel="noreferrer">
                        NO ANEXO 2
                    </a>{" "}
                    DESTA CONSULTA
                </li>
                <li>
                    ► ALVARÁS DE FUNCIONAMENTO DEVERÃO SER REQUERIDOS JUNTO AO
                    SITE EMPRESA FÁCIL
                </li>
                <li>
                    ► LOTES APROVADOS ATRAVÉS DA LEI 3960/2015 DEVERÃO SEGUIR OS
                    PARÂMTEROS ESTABELECIDOS PELA MESMA
                </li>
                <li>
                    ► RESIDÊNCIAS EM MADEIRA TERÃO SEUS RECUOS LATERAIS E FUNDOS
                    NO MÍNIMO COM 3,00m (TRÊS METROS) DA DIVISA, COM JANELAS.
                </li>
            </ul>
        </div>
    );
};
